<template>
  <div class="iconS">
    <div class="iconSty">
      <div>{{ infoArray.title }}</div>
      <div class="iconMoney mb-1" v-if="infoArray.eyeState">
        {{ infoArray.money | formatThous }}
      </div>
      <div class="iconMoney mb-1" v-else>******</div>
      <div class="eyeImg" @click="handleEye()">
        <img v-if="infoArray.eyeState" :src="infoArray.eyeOpen" alt="" />
        <img v-if="!infoArray.eyeState" :src="infoArray.eyeClose" alt="" />
      </div>

      <div class="allBtn">
        <ComButton
          v-for="(item, index) in infoArray.btnList"
          :key="index"
          @click="handleBtn(item)"
          :btnText="item.title"
          :disabled="item.type"
          :type="
            item.id == 1
              ? 'primaryAnother'
              : item.id == 2
              ? 'primary'
              : item.id == 3
              ? 'transferAccounts'
              : 'default'
          "
        ></ComButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComShowIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
    infoArray: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleEye() {
      this.$emit("handleEye");
    },
    handleBtn(data) {
      this.$emit("handleBtn", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>